import React from "react";
import { Routes, Route } from "react-router-dom";
import NishthaPage from "../screens/NishthaPage";

const NishthaRoutes: React.FC = () => (
  <Routes>
    <Route path="/" element={<NishthaPage />} />
  </Routes>
);

export default NishthaRoutes;
